//  首页数据发送
export const sendList = [
    // { img: require('@/assets/official/home_tab_vgm.png', title: 'VGM', contentTop: '全口岸覆盖 一站式通道', url: '/vgm' },
    // { img: require('@/assets/official/home_tab_cd.png', title: '上海-预配舱单', contentTop: '快速回执 智能审核', url: '/cps' },
    // { img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/home_tab_ams.png", title: 'AMS', contentTop: '提供SCAC code，', contentBtm: '无需 FMC Bond，安全简单' },
    // { img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/home_tab_afr.png", title: 'AFR', contentTop: '提供AFR code，', contentBtm: '快速回执，精准高' },
    // { img: require('@/assets/official/home_tab_en.png', title: 'EM&ACL', contentTop: '提供8000 code，', contentBtm: '安全高效，一键发送' },
    // { img: require('@/assets/official/home_tab_isf.png', title: 'ISF', contentTop: '敬请期待～' },
]

//  首页港区 
export const trackList = [
    { img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/home_tab_cx.png", title: '船期查询', contentTop: '实时更新 自动预警', contentBtm: '无需登录船公司，一键查询', url: '/shipping/schedule' },
    { img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/home_tab_gz.png", title: '跟踪', contentTop: '全域管理 周期预测', contentBtm: '支持网页版、微信订阅提醒', url: '/shipping/tracking' },
    // { img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/home_tab_track.png", title: '箱货跟踪', contentTop: '全程跟踪 风险管理', contentBtm: '支持网页版、微信订阅提醒', url: '/shipping/tracking?type=journey' },
]


//  国际物流RPA应用场景
export const robotList = [
    { img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/robot_tab_1.png", title: '智能订舱机器人', content: 'RPA机器人自动获取系统中的托书信息，登录对应的船公司网站，自动完成特定规则下的订舱操作。', videoSrc: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/video/AutoPreBookingForCOSCO.mp4' },
    { img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/robot_tab_2.png", title: '船期查询机器人', content: 'RPA机器人自动登录到船期查询网站，批量根据船名查询相应的航次、开截港时间等各类信息。', videoSrc: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/video/AutoGetInfoOfDestinationPort.mp4' },
    { img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/robot_tab_3.png", title: '数据发送机器人', content: 'RPA机器人获取VGM、舱单、AMS等信息，自动登录到数据发送平台完成数据发送操作。', videoSrc: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/video/AutoBookingForAMS.mp4' },
    { img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/robot_tab_4.png", title: '运价整理机器人', content: 'RPA机器人自动将零散的船公司发送过来的运价数据同步到本地系统中，构建集中、高效的运价管理体系。', videoSrc: '' },
    { img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/robot_tab_5.png", title: '财务对账机器人', content: 'RPA机器人每月月初根据公司财务对账规则，自动从系统中获取并核对上月交易明细，无误后自动生成对账单。', videoSrc: '' },
    { img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/robot_tab_6.png", title: '财务开票机器人', content: 'RPA机器人自动从业务系统中获取完整的开票信息，然后在开票软件中完成开票操作，并通知相关财务人员。', videoSrc: '' },
]

//  我们的案列
export const caseList = [
    { logo: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/robot_case_logo1.png", img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/robot_case_tab1.png", title: '欧坚集团', content1: '上海欧坚网络发展集团股份有限公司是中国最大的国际物流报关企业之一，主营业务包括跨境物流、跨境贸易、跨境清关、物流运输等在内的综合国际物流服务。目前，欧坚集团正利用互联网技术全方面为企业或个人提供“四位一体”的线上、线下通关服务。', content2: '未斯科技在与欧坚集团的沟通中发现，他们操作人员每天需要处理海量的纸质报关资料（报关委托书、报关单、销售合同、发票等），操作流程复杂，工作效率低下。因此，借助RPA机器人和OCR识别能力一键自动识别纸质报关单材料，并自动将报关信息录入集团系统中，不仅提升了操作人员的工作效率，降低了集团人力成本，而且为客户提供了更加高效、便捷的智能化服务。' },
    { logo: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/robot_case_logo2.png", img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/robot_case_tab2.png", title: '大木国际物流集团', content1: '大木国际物流集团有限公司成立于2001年，总部在上海。主营业务包含国际货运代理、船舶代理、场站仓配等多个国际物流配套服务。已先后在全国十几个主要港口和城市建立了多家分公司，并与全球70多个国家和地区的海外代理建立了长期良好的合作关系。', content2: '未斯科技积极参与到大木集团数字化建设中，在充分了解具体业务流程后，主导开发COSCO/马士基/OOCL/ONE自动订舱、运价自动管理、物流跟踪信息查询等流程，在帮助大木集团降本增效的同时，有效提升了集团内外业务协同效率，使其业务朝着数字化和智能化方向发展。' },
    // { logo: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/robot_case_logo3.png", img: "https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/robot_case_tab3.png", title: '密尔克卫', content1: '密尔克卫是一家专门做危险品货运的国际物流公司，在订舱环节根据客户发送过来的托书，将托书内容转化成船公司标准模版，并在船司网站上完成订舱工作，由于危险品订舱和普通商品订舱不同，有其特殊的要求，订舱完成后会生成提单模版，将数据填写到船公司模版中（结单），发送给船公司，订舱结单如果由于数据填写错误，公司将面临大额罚款。', content2: '如今使用RPA机器人，自动处理危险品订舱需要填报的特殊信息，将数据填写到船公司提单模版中完成结单操作，不再需要频繁投入大量人力填报信息，极大节省了人力成本，也大大减少了出错概率，不再面临巨额罚款。' },
]

/**
 * id 唯一标识
 * login_type 是否需要登录
 * enterpriseCertification 是否需要企业认证
 * show 显示与隐藏
 * openNewWindow 是否打开新窗口
 */
export const configList = [
    {
        icon: null,
        name: "数据发送",
        id: 30,
        show: true,
        openNewWindow: false,
        replaceUrl: false,
        child_node_list: [{
            child_node_list: null,
            jump_url: "/cps/draft",
            logo_url: "https://srfiles.yunquna.com/fe/common/eCommerce/2x/fywz.png",
            name: "上海-预配舱单",
            id: 31,
            show: true,
            productCode: 'shcps'
        },
        {
            child_node_list: null,
            jump_url: "/vgm/draft",
            logo_url: "https://srfiles.yunquna.com/fe/common/eCommerce/2x/fywz.png",
            name: "VGM发送",
            id: 32,
            show: true,
            productCode: 'vgm'
        }
        ],
    },
]
export const agentUrl = process.env.VUE_APP_BASE_AGENT